import { useEffect } from "react";

function Projects() {
  useEffect(() => {
    document.title = "kdo's projects 🩵";
  }, []);

  return (
    <div>
      <p>
        still cooking! nicer things coming soon. in the meantime, please check out my{" "}
        <a href="https://github.com/kdo1027" class="clickable" target="_blank" rel="noreferrer">
          github
        </a>{" "}
        <nobr>(´ ▽ `)✧</nobr>
      </p>
      <br />
      <p>
        <a href="https://github.com/kdo1027/finance-bro-agent" class="clickable" target="_blank" rel="noreferrer">finance bro agent</a>
        <br />
        agentic AI investment advisor
      </p>
      <p>
        <a href="https://github.com/comp423-26s/learn-with-ai-team-a1-1" class="clickable" target="_blank" rel="noreferrer">LearnWithAI</a>
        <br />
        ai-powered learning & practice platform
      </p>
      <p>
        <a href="https://pearlhacks.com/" class="clickable" target="_blank" rel="noreferrer">pearl hacks</a>
        <br />
        southeast’s largest gender minorities hackathon
      </p>
      <p>
        <a href="https://github.com/kdo1027/farmconnect" class="clickable" target="_blank" rel="noreferrer">farm connect</a>
        <br />
        WhatsApp chatbot for agricultural workers - targeting low-literacy users
      </p>
      <p>
        <a href="https://www.breastcancerhub.org/news-2/self-breast-exam-card" class="clickable" target="_blank" rel="noreferrer">breast cancer hub</a>
        <br />
        offline breast health self-examination app in 27 languages
      </p>
      <p>
        <a href="https://drive.google.com/file/d/1KQBO2g51r7quGE5_4Kvr_sKzmz6kcC4h/view?usp=sharing" class="clickable" target="_blank" rel="noreferrer">rocket health</a>
        <br />
        prevent adverse drug reactions 💊  
      </p>
      <p>
        <a href="https://github.com/kdo1027/threadchain" class="clickable" target="_blank" rel="noreferrer">threadchain</a>
        <br />
        decentralized threads application 🧵
      </p>
    </div>
  );
}

export default Projects;